import React from 'react';

interface FatigueLifeModalProps {
    id: string;
}

const FatigueLifeModal: React.FC<FatigueLifeModalProps> = ({
   id,
 }) => {
    return (
        <div>
            <h3>Contamination Factor</h3>
            <div className="c-search-modal__content--scroll">
                <div className="c-specs-table">
                    <table>
                        <caption className="sr-only">Contamination Factor</caption>
                        <thead>
                        <tr>
                            <th scope="col" className="">Level of contamination	</th>
                            <th scope="col" className="center-align">{"Dpw < 100mm"}</th>
                            <th scope="col" className="center-align">{"Dpw >= 100mm"}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr className="">
                            <td className="">
                                <strong>Extreme cleanliness</strong>
                                <p>Particle size of the order of lubricant film thickness; laboratory conditions</p>
                            </td>
                            <td className="center-align">1</td>
                            <td className="center-align">1</td>
                        </tr>
                        <tr className="">
                            <td className="">
                                <strong>High cleanliness</strong>
                                <p>Oil filtered through extremely fine filter; conditions typical of bearings greased for life and shielded</p>
                            </td>
                            <td className="center-align">0.8 to 0.6</td>
                            <td className="center-align">0.9 to 0.8</td>
                        </tr>
                        <tr className="">
                            <td className="">
                                <strong>Normal cleanliness</strong>
                                <p>Oil filtered through fine filter; conditions typical of bearing greased for life and shielded</p>
                            </td>
                            <td className="center-align">0.6 to 0.5</td>
                            <td className="center-align">0.8 to 0.6</td>
                        </tr>
                        <tr className="">
                            <td className="">
                                <strong>Slight contamination</strong>
                                <p>Slight contamination in lubricant</p>
                            </td>
                            <td className="center-align">0.5 to 0.3</td>
                            <td className="center-align">0.6 to 0.4</td>
                        </tr>
                        <tr className="">
                            <td className="">
                                <strong>Typical contamination</strong>
                                <p>Condition typical of bearings without integral seals; course filtering; wear particles and ingress from surroundings</p>
                            </td>
                            <td className="center-align">0.3 to 0.1</td>
                            <td className="center-align">0.4 to 0.2</td>
                        </tr>
                        <tr className="">
                            <td className="">
                                <strong>Severe contamination</strong>
                                <p>Bearing environment heavily contaminated and bearing arrangement with inadequate sealing</p>
                            </td>
                            <td className="center-align">0.1 to 0</td>
                            <td className="center-align">0.1 to 0</td>
                        </tr>
                        <tr className="">
                            <td className="">
                                <strong>Very severe contamination</strong>
                            </td>
                            <td className="center-align">0</td>
                            <td className="center-align">0</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default FatigueLifeModal;
